import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TenantResolver {
  
  /**
   * set tenant name
   * @param name 
   */
  setTenantName(name: string) {
    sessionStorage.setItem('tenant', name);
  }

  /**
   * get domain name
   * @returns 
   */
  getTenantName(): string | null {
    return sessionStorage.getItem('tenant');
  }

  clearTenantName() {
    sessionStorage.removeItem('tenant');
  }
  

}
